import { Tooltip } from '@fullstory/components';
import { APIPill, Metadata, ResourceDisplayPane } from '@fullstory/library-ui';
import React, { PropsWithChildren } from 'react';
import { APIEventBody } from '../APIEventBody';

interface ApiEventTooltipProps {
  eventName: string;
}

const fsApi = 'Fullstory API';

// todo(kevinwang): add updatedAt / last seen from custom schema
export const API_METADATA: Metadata = {
  owner: fsApi,
  createdBy: fsApi,
  createdAt: null,
  updatedBy: fsApi,
  updatedAt: null,
  rightAdornment: <APIPill />,
};

export const APIEventTooltip: React.FC<PropsWithChildren<ApiEventTooltipProps>> = ({
  eventName,
  children,
}) => (
  <Tooltip
    data-component="APIEventTooltip"
    disablePadding
    placement="right"
    maxWidth={400}
    variant="light"
    tooltipContent={
      <ResourceDisplayPane tooltip>
        <ResourceDisplayPane.Header label={eventName} />
        <ResourceDisplayPane.Body>
          <APIEventBody eventName={eventName} />
        </ResourceDisplayPane.Body>
        <ResourceDisplayPane.Footer metadata={API_METADATA} />
      </ResourceDisplayPane>
    }
  >
    {children}
  </Tooltip>
);
